import { PerkDefinition } from "./types";

/**
 * Boss Reflect perk - Stronger version of Thorns.
 * Reflects 2 damage per stack back to the attacker when taking damage.
 */
export const perkBossReflect = {
  id: "perk_boss_reflect",
  name: "Boss Reflect",
  description: "When you take damage, deal 2 damage back to the attacker.",
  apply: () => {
    // No stat modifications on apply
  },
  onDamageTaken: (_damageAmount, context) => {
    // Reflect 2 damage per stack back to the attacker
    const reflectionDamage = context.stackCount * 2;
    context.applyDamage(reflectionDamage);
    return 0; // No healing or additional effect
  },
} satisfies PerkDefinition<"perk_boss_reflect">;
